<template>
  <q-dialog v-if="getIsOpenModal" v-model="isOpenModal" persistent>
    <q-card class="card-content">
      <q-card-section class="items-center q-pa-xl">
        <div class="q-ml-sm modal-text">
          {{ modalText }}
          <span class="q-ml-sm env-text">{{ confirmCode }}</span>
        </div>
        <div class="flex justify-center q-mt-lg">
          <q-input
            outlined
            class="typed-code"
            v-model.number="typedCode"
          ></q-input>
        </div>
      </q-card-section>

      <q-card-actions align="right" class="q-mt-md">
        <q-btn flat label="Cancel" color="primary" @click="handlerCancel" />
        <q-btn
          flat
          label="Confirm"
          color="primary"
          @click="handlerConfirm"
          :disable="handlerCode()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ProdCacheModalConfirm",

  props: {
    handlerConfirm: {
      type: Function,
      require: false,
    },
    modalText: {
      type: String,
      require: true,
      default: "Put your text here!",
    },
    confirmCode: {
      type: Number,
      require: true,
    },
  },

  data() {
    return {
      isOpenModal: null,
      typedCode: null,
    };
  },

  computed: {
    ...mapGetters({ getIsOpenModal: "confirmModal/getIsOpenModal" }),
  },

  methods: {
    ...mapActions({
      setOpenModal: "confirmModal/setOpenModal",
    }),

    handlerCancel() {
      this.setOpenModal(false);
      this.isOpenModal = false;
    },

    handlerCode() {
      return this.confirmCode !== this.typedCode;
    },
  },

  mounted() {
    this.isOpenModal = this.getIsOpenModal;
  },
};
</script>

<style lang="scss" scoped>
img {
  background-color: $primary;
}

.modal-text {
  font-size: 24px;
}

.card-content {
  width: 600px;
  max-width: 800px;
}

.env-text {
  font-weight: bold;
  text-transform: uppercase;
  color: $negative;
}

.typed-code {
  width: 60%;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
